import PVSMIPServiceDetail from "./PVSMIPServiceDetail";

export default PVSMIPServiceDetail;
